import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Eye, EyeOff, Lock, Mail } from "lucide-react";
import logo from "../assets/logo.png";
import "./Admin.css";

export default function AdminLogin() {
  const [email,   setEmail]   = useState("");
  const [pw,      setPw]      = useState("");
  const [showPw,  setShowPw]  = useState(false);
  const [error,   setError]   = useState("");
  const [loading, setLoading] = useState(false);
  const { login }  = useAuth();
  const navigate   = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, pw);
      navigate("/admin/dashboard");
    } catch {
      setError("Invalid email or password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="star-bg" /><div className="grid-overlay" />
      <div className="login-card">
        <div className="login-header">
          <img src={logo} alt="Everlink" className="login-logo" />
          <h1>Admin Portal</h1>
          <p>Everlink Telesat Network Limited</p>
          <div className="secure-badge">
            <span className="secure-dot" /> Secured with Firebase JWT
          </div>
        </div>

        {error && <div className="login-error">⚠️ {error}</div>}

        <form onSubmit={submit}>
          <div className="login-field">
            <label><Mail size={13} /> Email Address</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              required placeholder="admin@everlinktelesat.com" />
          </div>
          <div className="login-field">
            <label><Lock size={13} /> Password</label>
            <div className="pw-wrap">
              <input type={showPw ? "text" : "password"} value={pw}
                onChange={(e) => setPw(e.target.value)} required placeholder="••••••••" />
              <button type="button" className="pw-toggle" onClick={() => setShowPw((s) => !s)}>
                {showPw ? <EyeOff size={15} /> : <Eye size={15} />}
              </button>
            </div>
          </div>
          <button type="submit" className="login-submit-btn" disabled={loading}>
            {loading ? "Signing in…" : "Sign In →"}
          </button>
        </form>

        <p className="login-note">
          Contact your IT administrator to reset credentials.
        </p>
        <a href="/" className="login-back">← Back to Website</a>
      </div>
    </div>
  );
}
